import { render, staticRenderFns } from "./BannerImage.vue?vue&type=template&id=3039e86f"
import script from "./BannerImage.vue?vue&type=script&lang=js"
export * from "./BannerImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports